/* import __COLOCATED_TEMPLATE__ from './copilot-state.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { AiContentState } from 'embercom/lib/ai-content-library/constants';

interface Args {
  copilotStates: AiContentState[];
  fingested?: boolean;
}

export default class CopilotState extends Component<Args> {
  stateWhenUsed = AiContentState.USED_BY_FIN;

  get hasStates(): boolean {
    return this.args.copilotStates && this.args.copilotStates.length > 0;
  }

  // returning true since there isn't any pre-condition for success state
  get preCondition(): boolean {
    return true;
  }

  get isIngesting(): boolean {
    return this.args.copilotStates.length === 1 &&
      this.args.copilotStates.firstObject === this.stateWhenUsed &&
      this.args.fingested !== undefined
      ? !this.args.fingested
      : false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::CopilotState': typeof CopilotState;
    'knowledge-hub/filterable-list/table/cells/copilot-state': typeof CopilotState;
  }
}
